//REACT
import React from "react";

//MATERIALS
import { Container } from "@mui/material";


//EXTERNAL IMPORTS
// import BalanceText from "react-balance-text";
import Helmet from "react-helmet";
import ShippingFooter from "../ShippingFooter/ShippingFooter";

//COMPONENTS
import BlogItem from "./BlogItem";
import { BigP } from "../styledComponents"

//HOOKS, UTILS, DATA
// import BlogData from "./BlogData";
import {getPagesByType, getPageData, SeoComponent, StructureDebug} from "../structure/jigpawsStructure";
import {DebugContainer} from "../Debug/Debug";

const blogs = getPagesByType("Blog").reverse();


const BlogsPage = () => {
    const pageData = getPageData({
    pageType: "Blog-Index",
    });
  return (
    <>
      <Helmet>
        {/*<title>Jigpaws – Blog</title>*/}
        {/*<meta*/}
        {/*  name="description"*/}
        {/*  content="Read all about the latest gift ideas for pet and animal lovers. "*/}
        {/*/>*/}
        {/*<link rel="canonical" href="https://www.jigpaws.com/blog" />*/}
        {/*<meta property="og:url" content="https://www.jigpaws.com/blog" />*/}
        {/*<meta property="og:type" content="article" />*/}
        {/*<meta property="og:title" content="content" />*/}
        {/*<meta*/}
        {/*  property="og:description"*/}
        {/*  content="Read all about the latest gift ideas for pet and animal lovers."*/}
        {/*/>*/}
        {/*<meta property="og:image" content="content" />*/}
      </Helmet>
        <SeoComponent page={pageData} />
                <DebugContainer><StructureDebug pageData={pageData}/></DebugContainer>
      <Container
        className={"productsHome bgGray"}
        align="center"
        disableGutters={true}
        maxWidth={false}
      >
        <div className="spacer" />
        <div className="headerContainer">
            <div>
                <h1>
                    Jigpaws Blog
                </h1>
                <div className="spacerSmall"/>
            </div>
            <div className="body leader">
              Read all about the latest gift ideas for pet and animal lovers.
              With top tips and Top 10 lists covering every occasion our blog is
              full of inspirational ideas and heartfelt stories for all…
          </div>
        </div>
        <div className="spacer" />
        <div className="jpDivider bgBlue" />
      </Container>

      <Container>
        <div className="jpBlogContainer">
          <div className="jpBlogContent ">
            {/*{BlogData.map((blog, index) => (*/}
            {/*  <BlogItem*/}
            {/*    key={index}*/}
            {/*    title={blog.title}*/}
            {/*    imageSrc={blog.imageSrc}*/}
            {/*    imageAlt={blog.imageAlt}*/}
            {/*    link={blog.link}*/}
            {/*    description={blog.description}*/}
            {/*  />*/}
            {/*))}*/}
              {blogs.map((blog, index) => (
  <BlogItem
    key={index}
    title={blog.content.h1}
    imageSrc={blog.image.src}
    imageAlt={blog.image.alt}
    link={blog.relLink}
    description={blog.meta.description}
  />
))}
          </div>
        </div>
      </Container>
      <ShippingFooter />
    </>
  );
};

export default BlogsPage;
